import script from "./goodsSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsSearch.vue?vue&type=script&setup=true&lang=js"

import "./goodsSearch.vue?vue&type=style&index=0&id=7571b28f&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7571b28f"]])

export default __exports__